<template>
  <div class="input-block" :class="{[formParam]:true,}">
    <form-birthday
      v-model="birthday"
      name="birthday"
      label="生年月日"
      placeholderYear="1999"
      placeholderMonth="09"
      placeholderDay="09"
      :validation="{ rules: {birthRange: true, required: true} }"
    />
  </div>
</template>

<script>
export default {
  name: 'InputBlockBirthday',
  data(){
    return {
      birthday: '',
      buttonIsDisabled: false,
    }
  },
  props: {
    dataSet: {
      type: Array,
      default: [],
    },
    formParam: {
      type: String,
      default: '',
    }
  },
  computed: {
    validateFlags () {
      return this.$validator.flags
    },
  },
  watch:{
    dataSet: {
      handler(val) {
        if (val.length > 0) {
          const inputs = this.$el.querySelectorAll('input')
          inputs.forEach(item => {
            item.value = ''
          })
        }
      },
      deep: true,
    },
    validateFlags: {
      handler(n) {
        const mtc = this.birthday.match(/.{2}/g)
        this.buttonIsDisabled = Object.keys(n).some((key)=> n[key].invalid)
        this.$emit('on-input', {
          key: this.formParam,
          disable: this.buttonIsDisabled,
          inputData: {
            birthday: this.buttonIsDisabled || !mtc ? '' : `${mtc[0]}${mtc[1]}-${mtc[2]}-${mtc[3]}`
          }
        })
      },
      deep: true
    },
  },
}</script>

<style scoped lang="scss">
.input-block {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/inputParts/InputBlockBirthday.vue